/**
 * Endereços e tamanhos das imagens do setor NSA do GOES-19 no CDN da NOAA/STAR.
 */
import { formatStarStamp } from './stamp';

export const STAR_SECTOR_URL = 'https://cdn.star.nesdis.noaa.gov/GOES19/ABI/SECTOR/nsa';

/** Página pública do setor (para links de crédito). */
export const STAR_SECTOR_PAGE = 'https://www.star.nesdis.noaa.gov/GOES/sector.php?sat=G19&sector=nsa';

/** Larguras publicadas (px). A altura é sempre 3/5 da largura (450x270 … 7200x4320). */
export const IMAGE_WIDTHS = [450, 900, 1800, 3600, 7200] as const;
export type ImageWidth = (typeof IMAGE_WIDTHS)[number];

export function isImageWidth(n: number): n is ImageWidth {
  return (IMAGE_WIDTHS as readonly number[]).includes(n);
}

export function imageHeight(width: ImageWidth): number {
  return (width * 3) / 5;
}

export function imagePixels(width: ImageWidth): number {
  return width * imageHeight(width);
}

/** Tamanho típico do arquivo (bytes, GeoColor) — usado quando a listagem não traz o tamanho. */
export const APPROX_BYTES: Record<ImageWidth, number> = {
  450: 120_000,
  900: 350_000,
  1800: 1_000_000,
  3600: 2_800_000,
  7200: 7_900_000,
};

/** Intervalo nominal entre quadros do setor NSA. */
export const FRAME_INTERVAL_MS = 10 * 60_000;

/** Diretório do produto (com barra final). A listagem HTML do nginx fica aqui. */
export function productDirUrl(productId: string): string {
  return `${STAR_SECTOR_URL}/${productId}/`;
}

export function frameFileName(productId: string, time: number, width: ImageWidth): string {
  return `${formatStarStamp(time)}_GOES19-ABI-nsa-${productId}-${width}x${imageHeight(width)}.jpg`;
}

export function frameUrl(productId: string, time: number, width: ImageWidth): string {
  return productDirUrl(productId) + frameFileName(productId, time, width);
}

/** Miniatura (450x270) do quadro mais recente. */
export function thumbnailUrl(productId: string): string {
  return `${productDirUrl(productId)}thumbnail.jpg`;
}
